import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { TaskStatusFormSettingsItemDto, type TaskStatusFormSettingsItemInterface } from '@zaoblako/shared/modules/task/dtos/status/task-status-form-settings-item.dto';

export interface TaskStatusFormSettingsInterface {
  date: TaskStatusFormSettingsItemInterface;
  subject: TaskStatusFormSettingsItemInterface;
  amount: TaskStatusFormSettingsItemInterface;
  vat: TaskStatusFormSettingsItemInterface;
  type: TaskStatusFormSettingsItemInterface;
  contragent: TaskStatusFormSettingsItemInterface;
  organization: TaskStatusFormSettingsItemInterface;
  unit: TaskStatusFormSettingsItemInterface;
  filial: TaskStatusFormSettingsItemInterface;
  direction: TaskStatusFormSettingsItemInterface;
  priority: TaskStatusFormSettingsItemInterface;
  nds: TaskStatusFormSettingsItemInterface;
  orders: TaskStatusFormSettingsItemInterface;
  files: TaskStatusFormSettingsItemInterface;
  userAuditors: TaskStatusFormSettingsItemInterface;
  userGroupAuditors: TaskStatusFormSettingsItemInterface;
  approvers: TaskStatusFormSettingsItemInterface;
  commentary: TaskStatusFormSettingsItemInterface;
  deal: TaskStatusFormSettingsItemInterface;
  costCenter: TaskStatusFormSettingsItemInterface;
}

export const TaskStatusFormSettingsDto = SerdeDtoClass.create<TaskStatusFormSettingsInterface>(TaskDtoKeysEnum.TASKS_STATUS_FORM_SETTINGS_FIND_DTO, {
  date: {
    label: 'Дата',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  subject: {
    label: 'Предмет',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  amount: {
    label: 'Количество',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  vat: {
    label: 'НДС',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  type: {
    label: 'Тип',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  contragent: {
    label: 'Контрагент',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  organization: {
    label: 'Организация',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  unit: {
    label: 'БЕ',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  filial: {
    label: 'Филиал',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  direction: {
    label: 'БС',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  priority: {
    label: 'Приоритет',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  nds: {
    label: 'НДС',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  orders: {
    label: 'Заказы',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  files: {
    label: 'Файлы',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  userAuditors: {
    label: 'Аудиторы',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  userGroupAuditors: {
    label: 'Группы аудиторов',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  approvers: {
    label: 'Согласователи',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  commentary: {
    label: 'Комментарий',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  deal: {
    label: 'Сделка',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
  costCenter: {
    label: 'Сделка',
    nested: TaskStatusFormSettingsItemDto,
    serializer: (_, nested) => nested,
  },
});
